"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var interfaces_1 = require("../Header/interfaces");
var Avatar_1 = __importDefault(require("../Avatar"));
var colors_1 = require("../ThemeProvider/colors");
var Tooltip_1 = __importDefault(require("../Tooltip"));
var useTranslations_1 = __importDefault(require("../Header/hooks/useTranslations"));
var prism_utilities_1 = require("@octanner/prism-utilities");
var styles_1 = require("./styles");
var Layout_1 = __importDefault(require("../context/Layout"));
var useEnabledPreferredPronouns_1 = require("../Header/hooks/useEnabledPreferredPronouns");
var useUserSearchConfigFields_1 = require("../Header/hooks/useUserSearchConfigFields");
var IdentityInfo = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var identity = _a.identity, _h = _a.color, color = _h === void 0 ? 'primary' : _h, _j = _a.isMobile, isMobile = _j === void 0 ? false : _j;
    var _k = __read((0, react_1.useContext)(Layout_1.default), 1), currentIdentityQuery = _k[0];
    var currentIdentity = (_b = currentIdentityQuery === null || currentIdentityQuery === void 0 ? void 0 : currentIdentityQuery.data) === null || _b === void 0 ? void 0 : _b.currentIdentity;
    var customerUuid = (_c = currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.customer) === null || _c === void 0 ? void 0 : _c.customerUuid;
    var enablePronounData = (0, useEnabledPreferredPronouns_1.useEnabledPreferredPronouns)(customerUuid).data;
    var pronounsEnabled = (_d = enablePronounData === null || enablePronounData === void 0 ? void 0 : enablePronounData.ccWebPreferredPronouns) === null || _d === void 0 ? void 0 : _d.enabled;
    var userSearchConfig = (0, useUserSearchConfigFields_1.useUserSearchConfigFields)(customerUuid);
    var customSearchFields = (_f = (_e = userSearchConfig === null || userSearchConfig === void 0 ? void 0 : userSearchConfig.data) === null || _e === void 0 ? void 0 : _e.ccWebUserSearchConfigEnabledFields) === null || _f === void 0 ? void 0 : _f.fields;
    var t = (0, useTranslations_1.default)().t;
    var textElementRef = (0, react_1.useRef)(null);
    var name = (0, prism_utilities_1.getFullName)(identity, pronounsEnabled);
    var primaryColor = color === 'primary' ? colors_1.tannerGray['900'] : colors_1.tannerWhite;
    var secondaryColor = color === 'primary' ? colors_1.tannerGray['600'] : '#ABABAE';
    var _l = __read((0, react_1.useState)(false), 2), disableTooltip = _l[0], setDisableTooltip = _l[1];
    var _m = __read((0, react_1.useState)(''), 2), searchFields = _m[0], setSearchFields = _m[1];
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (!textElementRef.current)
            return;
        setDisableTooltip(!(((_a = textElementRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) >
            ((_b = textElementRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth)));
    }, [searchFields, textElementRef]);
    var getSearchFields = (0, react_1.useMemo)(function () {
        var _a;
        var enabledFields = customSearchFields === null || customSearchFields === void 0 ? void 0 : customSearchFields.filter(function (field) { return field.enabled; });
        if ((enabledFields === null || enabledFields === void 0 ? void 0 : enabledFields.length) === 0)
            return [];
        var orderedEnabledFields = enabledFields === null || enabledFields === void 0 ? void 0 : enabledFields.sort(function (a, b) { return a.order - b.order; });
        var searchFields = orderedEnabledFields === null || orderedEnabledFields === void 0 ? void 0 : orderedEnabledFields.map(function (field) { return field.fieldType; });
        var work1CoreLocation = (_a = identity === null || identity === void 0 ? void 0 : identity.profile) === null || _a === void 0 ? void 0 : _a.work1CoreLocation;
        return searchFields === null || searchFields === void 0 ? void 0 : searchFields.map(function (field) {
            var _a, _b, _c, _d;
            switch (field) {
                case interfaces_1.FieldTypes.EmailAddress:
                    return (identity === null || identity === void 0 ? void 0 : identity.email) ? "".concat(identity.email) : '';
                case interfaces_1.FieldTypes.EmployeeId:
                    return (identity === null || identity === void 0 ? void 0 : identity.uniqueId) ? "".concat(identity.uniqueId) : '';
                case interfaces_1.FieldTypes.BusinessUnit:
                    return ((_a = identity === null || identity === void 0 ? void 0 : identity.businessUnit) === null || _a === void 0 ? void 0 : _a.buName)
                        ? "".concat(identity.businessUnit.buName)
                        : '';
                case interfaces_1.FieldTypes.LeaderName:
                    return (identity === null || identity === void 0 ? void 0 : identity.manager)
                        ? "".concat(t('prism-header:leader', 'Leader'), ": ").concat((0, prism_utilities_1.getFullName)(identity.manager, pronounsEnabled))
                        : '';
                case interfaces_1.FieldTypes.ParentBusinessUnit:
                    return ((_c = (_b = identity === null || identity === void 0 ? void 0 : identity.businessUnit) === null || _b === void 0 ? void 0 : _b.parentBusinessUnit) === null || _c === void 0 ? void 0 : _c.buName)
                        ? "".concat(identity.businessUnit.parentBusinessUnit.buName)
                        : '';
                case interfaces_1.FieldTypes.JobTitle:
                    return (identity === null || identity === void 0 ? void 0 : identity.jobTitle)
                        ? "".concat(identity.jobTitle)
                        : "".concat((_d = identity.businessUnit) === null || _d === void 0 ? void 0 : _d.buName);
                case interfaces_1.FieldTypes.WorkLocation:
                    return work1CoreLocation
                        ? "".concat(work1CoreLocation.city, ", ").concat(work1CoreLocation.state, ", ").concat(work1CoreLocation.country)
                        : '';
                case interfaces_1.FieldTypes.WorkLocationCondensed:
                    return (identity === null || identity === void 0 ? void 0 : identity.segmentOfficelocation)
                        ? "".concat(identity.segmentOfficelocation)
                        : '';
            }
        });
    }, [customSearchFields, identity, t]);
    var displaySearchFields = (0, react_1.useMemo)(function () {
        var hasField = false;
        return ((getSearchFields === null || getSearchFields === void 0 ? void 0 : getSearchFields.map(function (field) {
            if (!field)
                return field;
            if (!hasField) {
                hasField = true;
                return field;
            }
            return " \u2022 ".concat(field);
        }).filter(Boolean).join('')) || '');
    }, [getSearchFields]);
    (0, react_1.useEffect)(function () {
        if ((customSearchFields === null || customSearchFields === void 0 ? void 0 : customSearchFields.filter(function (field) { return field.enabled; }).length) === 0) {
            setDisableTooltip(true);
        }
        else {
            setSearchFields(displaySearchFields);
        }
    }, [customSearchFields, displaySearchFields]);
    return (react_1.default.createElement(styles_1.Container, { "aria-label": name + ' ' + displaySearchFields },
        react_1.default.createElement(Tooltip_1.default, { title: displaySearchFields, placement: "bottom-end", disableHoverListener: isMobile || disableTooltip, "data-testid": 'identity-tooltip:' + identity.uniqueId, disableInteractive: true },
            react_1.default.createElement(styles_1.IdentityContainer, { key: identity.identityUuid },
                react_1.default.createElement(Avatar_1.default, { src: (_g = identity.profile) === null || _g === void 0 ? void 0 : _g.avatar, alt: name, size: "md" }),
                react_1.default.createElement(styles_1.NameWrapper, null,
                    react_1.default.createElement(styles_1.Text, { color: primaryColor, "data-testid": 'identity-name:' + identity.uniqueId, "aria-label": name }, name),
                    react_1.default.createElement(styles_1.Text, { secondary: true, color: secondaryColor, ref: textElementRef, "data-testid": 'identity-search-fields:' + (identity === null || identity === void 0 ? void 0 : identity.uniqueId), "aria-label": searchFields }, searchFields))))));
};
exports.default = IdentityInfo;
//# sourceMappingURL=IdentityInfo.js.map